import { ICreateVideoCategoryState } from './createVideoCategoryContext';
import { CreateVideoCategoryActionTypes, TCreateVideoCategoryAction } from './createVideoCategoryActions';

export const createVideoCategoryReducer = (
	state: ICreateVideoCategoryState,
	action: TCreateVideoCategoryAction,
): ICreateVideoCategoryState => {
	switch (action.type) {
		case CreateVideoCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateVideoCategoryActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateVideoCategoryActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case CreateVideoCategoryActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case CreateVideoCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case CreateVideoCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateVideoCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case CreateVideoCategoryActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateVideoCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateVideoCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				translations: [],
			};
		default:
			return state;
	}
};
